const state = {
  muteSoundOptions: {
    muteSoundAll: false,
    muteSoundCalls: "onlyNotCalls",
    muteOnWaitingQueueSoundCalls: true,
    muteSoundCallsBucle: true,
    muteSoundNotifications: true,
    muteSoundNotificationsBucle: true,
  },
};

const mutations = {
  setMuteSoundOptions(state, options) {
    state.muteSoundOptions = options;
  },
};

const actions = {};

const getters = {
  muteSoundOptions(state) {
    return state.muteSoundOptions;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
